import { aiMentionApi } from '../../api/aiAssistant';
import { useCompany } from '../../hooks/company';
import MentionTag, { MentionInfoRow } from './MentionTag';

const STATE_LABELS: Record<string, string> = {
  ACTIVE: '在职',
  INACTIVE: '停用',
  DELETED: '已删除',
};

interface Props {
  name: string;
  userId: string;
}

/** 消息里的员工提及：渲染成 @姓名，hover 弹出员工信息卡 */
const MentionUser = ({ name, userId }: Props) => {
  const { id: companyId } = useCompany();

  const load = async (): Promise<MentionInfoRow[] | null> => {
    const list = await aiMentionApi.lookup(companyId, [userId]);
    const info = list.find((u) => String(u.userId) === userId);
    if (!info) {
      return null;
    }
    return [
      ['姓名', info.name],
      ['工号', String(info.userId)],
      ['部门', info.departmentName || '—'],
      ['角色', info.roleName || '—'],
      ['状态', STATE_LABELS[info.state || ''] || info.state || '—'],
      ['手机号', info.mobileMasked || '—'],
    ];
  };

  return (
    <MentionTag
      label={`@${name}`}
      color="#1677ff"
      background="rgba(22, 119, 255, 0.1)"
      cacheKey={`user:${companyId}:${userId}`}
      load={load}
      missingText="无权查看该员工信息或员工不存在"
    />
  );
};

export default MentionUser;
